import { useEffect } from 'react';

// Человекочитаемый ярлык текущего экрана/режима для контекста обратной связи.
// Нужен там, где URL одинаковый, а UI разный (напр. /tournaments/:id — DRAFT/RUNNING/
// FINISHED + режим редактирования; /events/:id — просмотр/редактирование/правка состава).
// Хранится в модульной переменной (не в React-состоянии) — читается из collectFeedbackContext.
let currentScreen = null;

export const setFeedbackScreen = (label) => { currentScreen = label || null; };
export const getFeedbackScreen = () => currentScreen;

/**
 * Регистрирует ярлык текущего экрана на время жизни компонента.
 * Обновляется при смене label, очищается при размонтировании.
 *
 * @param {string|null} label напр. «Турнир · RUNNING · редактирование»
 */
export const useFeedbackScreen = (label) => {
  useEffect(() => {
    setFeedbackScreen(label);
    return () => setFeedbackScreen(null);
  }, [label]);
};
